import { render, staticRenderFns } from "./MonProrasi.vue?vue&type=template&id=051aba4f"
import script from "./MonProrasi.vue?vue&type=script&lang=js"
export * from "./MonProrasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports